var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E61D0027-2DE5-4EAF-9E36-2D90253A012D_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Muuda-Andmeid",
    transform: "translate(-784.000000, -905.000000)",
    stroke: "#facd00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(752.000000, 557.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(24.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Check_White-16px",
    points: "9 15.2857143 14.4545455 21 24 11"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_Check_Yellow-16px.c64d5a77c5bbf80c81f0770baa25a968.svg";
export { ForwardRef as ReactComponent };